<template>
  <v-container class="ma-0 pa-0">
    <poll-discussion
      :questionID="questionID"
      :getQuestionFunc="getQuestionFunc"
      :getPollFunc="getPollFunc"
      :getCommentsFunc="getCommentsFunc"
      :createCommentFunc="createCommentFunc"
      :updateCommentFunc="updateCommentFunc"
      :deleteCommentFunc="deleteCommentFunc"
      :voteUpCommentFunc="voteUpCommentFunc"
      :voteDownCommentFunc="voteDownCommentFunc"
      :readCommentFunc="readCommentFunc"
      :createCommentAttachmentFormDataFunc="createCommentAttachmentFormDataFunc"
      :createCommentAttachmentFunc="createCommentAttachmentFunc"
      :updateCommentAttachmentFormDataFunc="updateCommentAttachmentFormDataFunc"
      :updateCommentAttachmentFunc="updateCommentAttachmentFunc"
      :deleteCommentAttachmentFunc="deleteCommentAttachmentFunc"
    ></poll-discussion>
  </v-container>
</template>
<script>
import PollDiscussion from "@/components/poll/discussion/PollDiscussion.vue";
import { APIService } from "@/http/APIService.js";

const apiService = new APIService();

export default {
  components: {
    PollDiscussion
  },

  computed: {
    questionID() { return parseInt(this.$route.params.questionID) }
  },

  methods: {
    getQuestionFunc(id) {
      return apiService.getGeneralPollQuestion(id);
    },

    getPollFunc(id) {
      return apiService.getGeneralPoll(id);
    },

    getCommentsFunc(sort, search, limit, offset, filter) {
      return apiService.getGeneralPollQuestionComments(sort, search, limit, offset, filter);
    },

    createCommentFunc(item) {
      return apiService.createGeneralPollQuestionComment(item);
    },

    updateCommentFunc(item) {
      return apiService.updateGeneralPollQuestionComment(item);
    },

    deleteCommentFunc(id) {
      return apiService.deleteGeneralPollQuestionComment(id);
    },

    voteUpCommentFunc(id) {
      return apiService.voteUpGeneralPollQuestionComment(id);
    },

    voteDownCommentFunc(id) {
      return apiService.voteDownGeneralPollQuestionComment(id);
    },

    readCommentFunc(id) {
      return apiService.generalPollQuestionCommentRead(id);
    },

    createCommentAttachmentFormDataFunc(data) {
      return apiService.createGeneralPollQuestionCommentAttachmentFormData(data);
    },

    createCommentAttachmentFunc(data) {
      return apiService.createGeneralPollQuestionCommentAttachment(data);
    },

    updateCommentAttachmentFormDataFunc(data) {
      return apiService.updateGeneralPollQuestionCommentAttachmentFormData(data);
    },

    updateCommentAttachmentFunc(data) {
      return apiService.updateGeneralPollQuestionCommentAttachment(data);
    },

    deleteCommentAttachmentFunc(data) {
      return apiService.deleteGeneralPollQuestionCommentAttachment(data);
    },
  }
}
</script>